/**
 * Created by Ivan on 22.05.2025
 */

const InitTutorial = function () {
    return new TutorialScenario(InitTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(InitTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.hand.setCards(InitTutorial.CONFIG.handValues);
            Game.currentGame.shownTutorials.push(InitTutorial.NAME);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(InitTutorial.NAME)
    });
};

InitTutorial.NAME = TutorialScenario.BASIC_TUTORIAL_NAME;
InitTutorial.CONFIG = {
    handValues: ["2h"],
    force: "InitialTutorialMessage1"
};
